export const i18nText: any = {
    za: {
        OutdoorRecreation: {
            title: 'Sign up for <yellow>R500 off</yellow> and explore outdoor power solutions.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        RoadTrips: {
            title: 'Claim <yellow>R500 off</yellow> when you sign up for travel-friendly power updates.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
    },
    au: {
        HomeBackup: {
            title: 'Get <yellow>$79 off</yellow> when you sign up for home backup updates.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OutdoorRecreation: {
            title: 'Sign up now for <yellow>$79 off</yellow> and discover outdoor power solutions.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        RoadTrips: {
            title: 'Subscribe for <yellow>$79 off</yellow> and explore home backup solutions.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
    },
    kr: {
        HomeBackup: {
            title: '가정용 백업 솔루션 업데이트, 뉴스 등을 구독하세요.',
            placeholder: '이메일',
            btn: '구독',
            checkbox: '이 양식을 제출함으로써, 나는 <link1>이용 약관</link1> 및 <link2>개인정보</link2> 처리방침을 동의합니다.',
            tips_succ: '성공적으로 제출되었습니다',
            tips_error: '유효한 이메일 주소를 입력하세요',
            tips_checked: '확인란을 선택하고 이용약관 및 개인정보 보호정책에 동의합니다.',
        },
        OutdoorRecreation: {
            title: '가입하여 야외 전원 솔루션, 뉴스 등을 살펴보세요.',
            placeholder: '이메일',
            btn: '구독',
            checkbox: '이 양식을 제출함으로써, 나는 <link1>이용 약관</link1> 및 <link2>개인정보</link2> 처리방침을 동의합니다.',
            tips_succ: '성공적으로 제출되었습니다',
            tips_error: '유효한 이메일 주소를 입력하세요',
            tips_checked: '확인란을 선택하고 이용약관 및 개인정보 보호정책에 동의합니다.',
        },
        RoadTrips: {
            title: '가입하여 여행 친화적인 전원 업데이트, 뉴스 등을 받아보세요.',
            placeholder: '이메일',
            btn: '구독',
            checkbox: '이 양식을 제출함으로써, 나는 <link1>이용 약관</link1> 및 <link2>개인정보</link2> 처리방침을 동의합니다.',
            tips_succ: '성공적으로 제출되었습니다',
            tips_error: '유효한 이메일 주소를 입력하세요',
            tips_checked: '확인란을 선택하고 이용약관 및 개인정보 보호정책에 동의합니다.',
        },
    },
    eu: {
        PowerIndependence: {
            title: 'Unlock power independence updates: <yellow>€25 discount</yellow> for new sign-ups!',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OutdoorRecreation: {
            title: 'Sign up for <yellow>€25 off</yellow> and discover outdoor power solutions.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        RoadTrips: {
            title: 'Get <yellow>€25 off</yellow> when you sign up for travel-friendly power updates.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
    },
    uk: {
        PowerIndependence: {
            title: 'Unlock power independence updates: <yellow>€25 discount</yellow> for new sign-ups!',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OutdoorRecreation: {
            title: 'Sign up for <yellow>€25 off</yellow> and discover outdoor power solutions.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        RoadTrips: {
            title: 'Get <yellow>€25 off</yellow> when you sign up for travel-friendly power updates.',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
    },
    de: {
        PowerIndependence: {
            title: 'Energieautarkie ist machbar: Bleiben Sie informiert: <yellow>25 € Rabatt</yellow> für Neuanmeldungen!',
            placeholder: 'E-Mail Adresse',
            btn: 'Abonnieren',
            checkbox:
                'Indem ich dieses Formular einreiche, akzeptiere ich die <link1>Nutzungsbedingungen</link1> und <link2>Datenschutzbestimmungen</link2> einverstanden.',
            tips_succ: 'erfolgreich eingereicht',
            tips_error: 'Bitte geben Sie eine gültige Nachricht ein',
            tips_checked: 'Markieren Sie das Kästchen und stimmen Sie den Nutzungsbedingungen und der Datenschutzrichtlinie zu.',
        },
        OutdoorRecreation: {
            title: 'Energie-News für Ihre Outdoor-Abenteuer: Anmelden und <yellow>25 € sparen</yellow>.',
            placeholder: 'E-Mail Adresse',
            btn: 'Abonnieren',
            checkbox:
                'Indem ich dieses Formular einreiche, akzeptiere ich die <link1>Nutzungsbedingungen</link1> und <link2>Datenschutzbestimmungen</link2> einverstanden.',
            tips_succ: 'erfolgreich eingereicht',
            tips_error: 'Bitte geben Sie eine gültige Nachricht ein',
            tips_checked: 'Markieren Sie das Kästchen und stimmen Sie den Nutzungsbedingungen und der Datenschutzrichtlinie zu.',
        },
        RoadTrips: {
            title: 'Unterwegs in frischer Energie. Bleiben Sie informiert: <yellow>25 € Rabatt</yellow> für Neuanmeldungen!',
            placeholder: 'E-Mail Adresse',
            btn: 'Abonnieren',
            checkbox:
                'Indem ich dieses Formular einreiche, akzeptiere ich die <link1>Nutzungsbedingungen</link1> und <link2>Datenschutzbestimmungen</link2> einverstanden.',
            tips_succ: 'erfolgreich eingereicht',
            tips_error: 'Bitte geben Sie eine gültige Nachricht ein',
            tips_checked: 'Markieren Sie das Kästchen und stimmen Sie den Nutzungsbedingungen und der Datenschutzrichtlinie zu.',
        },
    },
    fr: {
        PowerIndependence: {
            title: 'Obtenez un bon de <yellow>25 €</yellow> en vous abonnant à notre newsletter et profitez de nos meilleures réductions sur nos solutions énergétiques autonomes.',
            placeholder: 'Adresse e-mail',
            btn: "S'abonner",
            checkbox: "En soumettant ce formulaire, j'accepte <link1>les Conditions d'utilisation</link1> notre <link2>Politique de confidentialité.</link2>",
            tips_succ: 'Soumis avec succès',
            tips_error: 'Veuillez entrer un e-mail valide',
            tips_checked: "Cochez la case et acceptez les conditions d'utilisation et la politique de confidentialité.",
        },
        OutdoorRecreation: {
            title: 'Abonnez-vous pour obtenir un bon de <yellow>25 €</yellow> et profitez de nos meilleures réductions sur nos solutions énergétiques portables.',
            placeholder: 'Adresse e-mail',
            btn: "S'abonner",
            checkbox: "En soumettant ce formulaire, j'accepte <link1>les Conditions d'utilisation</link1> notre <link2>Politique de confidentialité.</link2>",
            tips_succ: 'Soumis avec succès',
            tips_error: 'Veuillez entrer un e-mail valide',
            tips_checked: "Cochez la case et acceptez les conditions d'utilisation et la politique de confidentialité.",
        },
        RoadTrips: {
            title: 'Obtenez un bon de <yellow>25 €</yellow> en vous abonnant à notre newsletter et profitez de nos meilleures réductions sur nos solutions énergétiques nomades.',
            placeholder: 'Adresse e-mail',
            btn: "S'abonner",
            checkbox: "En soumettant ce formulaire, j'accepte <link1>les Conditions d'utilisation</link1> notre <link2>Politique de confidentialité.</link2>",
            tips_succ: 'Soumis avec succès',
            tips_error: 'Veuillez entrer un e-mail valide',
            tips_checked: "Cochez la case et acceptez les conditions d'utilisation et la politique de confidentialité.",
        },
    },
    it: {
        PowerIndependence: {
            title: 'Ricevi aggiornamenti sulle soluzioni di indipendenza energetica: <yellow>25 €</yellow> di sconto per i nuovi iscritti!',
            placeholder: 'E-mail',
            btn: 'Iscriviti',
            checkbox: "Inviando questo modulo, accetto <link1>i Termini di utilizzo</link1> e <link2>l'Informativa sulla privacy</link2>.",
            tips_succ: 'Inserito con successo',
            tips_error: 'Inserisci un e-mail valido',
            tips_checked: "Seleziona la casella e acconsenti ai Termini di utilizzo e all'Informativa sulla privacy.",
        },
        OutdoorRecreation: {
            title: 'Iscriviti, ricevi <yellow>25 €</yellow> di sconto e scopri le soluzioni energetiche ad uso esterno.',
            placeholder: 'E-mail',
            btn: 'Iscriviti',
            checkbox: "Inviando questo modulo, accetto <link1>i Termini di utilizzo</link1> e <link2>l'Informativa sulla privacy</link2>.",
            tips_succ: 'Inserito con successo',
            tips_error: 'Inserisci un e-mail valido',
            tips_checked: "Seleziona la casella e acconsenti ai Termini di utilizzo e all'Informativa sulla privacy.",
        },
        RoadTrips: {
            title: 'Ricevi <yellow>25 €</yellow> di sconto effettuando l’iscrizione agli aggiornamenti sulle soluzioni energetiche da viaggio.',
            placeholder: 'E-mail',
            btn: 'Iscriviti',
            checkbox: "Inviando questo modulo, accetto <link1>i Termini di utilizzo</link1> e <link2>l'Informativa sulla privacy</link2>.",
            tips_succ: 'Inserito con successo',
            tips_error: 'Inserisci un e-mail valido',
            tips_checked: "Seleziona la casella e acconsenti ai Termini di utilizzo e all'Informativa sulla privacy.",
        },
    },
    es: {
        PowerIndependence: {
            title: 'Descubre novedades sobre la independencia energética: ¡<yellow>25 €</yellow> de descuento para las nuevas inscripciones!',
            placeholder: 'Correo electrónico',
            btn: 'Suscribirse',
            checkbox: 'Al enviar este formulario, acepto <link1>los Términos de uso</link1> y <link2>la Política de privacidad</link2>.',
            tips_succ: 'Enviado satisfactoriamente',
            tips_error: 'Por favor introduce un mensaje válido',
            tips_checked: 'Marque la casilla y acepte los Términos de uso y la Política de privacidad.',
        },
        OutdoorRecreation: {
            title: 'Regístrate para obtener <yellow>25 €</yellow> de descuento y descubrir soluciones de energía para exteriores.',
            placeholder: 'Correo electrónico',
            btn: 'Suscribirse',
            checkbox: 'Al enviar este formulario, acepto <link1>los Términos de uso</link1> y <link2>la Política de privacidad</link2>.',
            tips_succ: 'Enviado satisfactoriamente',
            tips_error: 'Por favor introduce un mensaje válido',
            tips_checked: 'Marque la casilla y acepte los Términos de uso y la Política de privacidad.',
        },
        RoadTrips: {
            title: 'Obtén <yellow>25 €</yellow> de descuento por suscribirte a las novedades sobre soluciones de energía para tus viajes.',
            placeholder: 'Correo electrónico',
            btn: 'Suscribirse',
            checkbox: 'Al enviar este formulario, acepto <link1>los Términos de uso</link1> y <link2>la Política de privacidad</link2>.',
            tips_succ: 'Enviado satisfactoriamente',
            tips_error: 'Por favor introduce un mensaje válido',
            tips_checked: 'Marque la casilla y acepte los Términos de uso y la Política de privacidad.',
        },
    },
    us: {
        HomeBackup: {
            title: 'Subscribe for home backup solution updates, news, and more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        BatteryBackupForHome: {
            title: 'Sign up to unlock special deals on more EcoFlow emergency backup solutions!',
            subTitle: '',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OutdoorRecreation: {
            title: 'Subscribe for outdoor power solutions, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        RoadTrips: {
            title: 'Subscribe for travel-friendly power updates, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        CostSaving: {
            title: 'Join today for tips and news on how to cut energy costs with solar!',
            placeholder: 'Email',
            btn: 'Subscribe',
            checkbox: 'By submitting this form, I accept the <link1>Terms of Use</link1> and <link2>Privacy Policy.</link2>',
            tips_succ: 'Submitted successfully',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OffGrid: {
            title: 'Subscribe for off-grid power solutions updates, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
    },
    ca: {
        HomeBackup: {
            title: 'Subscribe for home backup solution updates, news, and more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        BatteryBackupForHome: {
            title: 'Sign up to unlock special deals on more EcoFlow emergency backup solutions!',
            subTitle: '',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OutdoorRecreation: {
            title: 'Subscribe for outdoor power solutions, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        RoadTrips: {
            title: 'Subscribe for travel-friendly power updates, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        CostSaving: {
            title: 'Subscribe for cost-savings power solutions updates, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
        OffGrid: {
            title: 'Subscribe for off-grid power solutions updates, news & more',
            subTitle: '– and enjoy <blue>5% off</blue> paired with coupons worth <blue>$1,000+</blue> with your first sign-up!',
            placeholder: 'Provide your email',
            btn: 'Subscribe',
            checkbox: "I agree to EcoFlow's <link2>Privacy Policy</link2> and <link1>Terms of Service</link1>.",
            tips_succ: 'Sign up successfully! Check your inbox for coupons.',
            tips_error: 'Please enter a valid email',
            tips_checked: 'Tick the box and consent to the Terms of Use and Privacy Policy.',
        },
    },
    jp: {
        HomeBattery: {
            title: '家庭用蓄電池に関する最新情報をニュースレターで配信中、今すぐ購読しよう！',
            placeholder: 'メールアドレスを入力する',
            btn: '送信',
            checkbox: 'EcoFlow の<link2>プライバシーポリシー</link2>と<link1>利用規約</link1>に同意します',
            tips_succ: '正常に送信されました',
            tips_error: '有効なメールアドレスをご入力ください。',
            tips_checked: 'ボックスをチェックをして、利用規約とプライバシー ポリシーに同意してください。',
        },
        Vanlife: {
            title: 'ニュースレターに登録して、アウトドアや車中泊に最適なバッテリーの最新情報を無料で手に入れよう！',
            placeholder: 'メールアドレスを入力する',
            btn: '送信',
            checkbox: 'EcoFlow の<link2>プライバシーポリシー</link2>と<link1>利用規約</link1>に同意します',
            tips_succ: '正常に送信されました',
            tips_error: '有効なメールアドレスをご入力ください。',
            tips_checked: 'ボックスをチェックをして、利用規約とプライバシー ポリシーに同意してください。',
        },
        Camp: {
            title: 'ニュースレターに登録して、旅行に便利なバッテリーの最新情報を無料で手に入れよう！',
            placeholder: 'メールアドレスを入力する',
            btn: '送信',
            checkbox: 'EcoFlow の<link2>プライバシーポリシー</link2>と<link1>利用規約</link1>に同意します',
            tips_succ: '正常に送信されました',
            tips_error: '有効なメールアドレスをご入力ください。',
            tips_checked: 'ボックスをチェックをして、利用規約とプライバシー ポリシーに同意してください。',
        },
        Save: {
            title: 'メルマガ登録で\n5%OFFクーポンゲット！',
            subTitle: 'メールマガジンにご登録いただくと、限定の5％割引クーポンとEcoFlowの省エネルギーソリューションに関する最新情報をお届けします',
            placeholder: 'メールアドレス',
            btn: '今すぐ登録',
            checkbox: 'EcoFlow の<link2>プライバシーポリシー</link2>と<link1>利用規約</link1>に同意します',
            tips_succ: 'ご登録ありがとうございます！、\nご登録いただいたメールアドレスに5%OFFクーポンを送付しました。',
            tips_error: '有効なメールアドレスをご入力ください。',
            tips_checked: 'ボックスをチェックをして、利用規約とプライバシー ポリシーに同意してください。',
        },
    },
};
